"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessToken = void 0;
class AccessToken {
    constructor(_accessToken) {
        this._accessToken = _accessToken;
    }
    get(handleInvalidToken) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._accessToken || (yield handleInvalidToken());
        });
    }
}
exports.AccessToken = AccessToken;
